export function setDidomiConsentCheck(callback: () => Promise<boolean>) {
  console.log('[facebook][web] Didomi consent check callback registered (no-op on web)');
}

export async function initializeFacebookSdk(): Promise<void> {
  console.log('[facebook][web] Facebook SDK not available on web platform');
}

export async function trackAppActivation(): Promise<void> {
  console.log('[facebook][web] trackAppActivation not available on web platform');
}

export async function trackAppFirstOpen(): Promise<void> {
  console.log('[facebook][web] trackAppFirstOpen not available on web platform');
}

export async function trackCustomEvent(eventName: string, parameters?: Record<string, any>): Promise<void> {
  console.log('[facebook][web] trackCustomEvent not available on web platform:', eventName);
}

export async function setUserId(userId: string | null): Promise<void> {
  console.log('[facebook][web] setUserId not available on web platform');
}

export const facebookTracking = {
  initializeFacebookSdk,
  trackAppActivation,
  trackAppFirstOpen,
  trackCustomEvent,
  setUserId,
  setDidomiConsentCheck,
};
